import { useEffect, useState } from "react";
import {
  AUTH_SESSION_CHANGED_EVENT,
  readAuthToken,
} from "@/shared/utils/authSession.util";

/**
 * Portal client auth. Token is kept in React state and synced when login/logout
 * updates the cookie so route/layout trees re-render without a full page reload.
 */
export function useAuth() {
  const [hasMounted, setHasMounted] = useState(false);
  const [token, setToken] = useState<string | null>(() => readAuthToken());

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    const syncToken = () => setToken(readAuthToken());
    syncToken();
    window.addEventListener(AUTH_SESSION_CHANGED_EVENT, syncToken);
    return () => window.removeEventListener(AUTH_SESSION_CHANGED_EVENT, syncToken);
  }, []);

  return {
    token,
    isAuthenticated: Boolean(token),
    /** One tick after mount avoids treating the very first paint as “logged out” before hydration. */
    isLoading: !hasMounted,
  };
}
